module.exports = __webpack_public_path__ + "img/salud-nutricion.c9f9bada.jpg";